/* eslint-disable max-statements */
// eslint-disable-next-line react-hooks/exhaustive-deps
import React, { useEffect, Fragment, useState, useMemo} from "react";
import { bindActionCreators } from "redux";
import { LazyComponent } from "../../../components/shared/lazy-image";
import withLayout from "../../../components/desktop/layout/component";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { homeVariation } from "../../../variations/home";
import ErrorHandler from "../../../components/shared/with-error-handler";
import SchemaHome from "../../../components/shared/schema-homepage";
import { sendGAEvent, sendCustomGaEvents } from "../../../tracking";
import loadable from "@loadable/component";
import querystring from "querystring";
import { setDealerCode, updateLeadSource } from "../../../components/desktop/settings/actions";
import { breadcrumbClicked } from "../../../constants/tracking-constants/breadcrumb";
import { appUrl } from "../../../constants/url-constants";
const BreadcrumbList = loadable(() => import("../../../components/shared/breadcrumb-list"), {ssr: true});
import { getCarPriceInPageCTA, sellCarNowInPageCTA, popularCityTextClick, getCarPriceBottom } from "./tracking";
import { fetchData, updateSSRStatus } from "../../../components/shared/meta-tags/actions";
import { SELL_CAR_SEO_INFO_SECTIONS } from "./constant";

import HomeBanner  from "../../../components/desktop/home-banner";
import SellEasySteps from "../../../components/desktop/sell-easy-steps";
import { dealerCodeValidator } from "../../../utils/validators/dealer-code-validator";
import { C2B_LEAD_TYPES } from "../../../constants/seller-lead-types";
import withReducer from "../../../components/shared/with-reducer";
import injectableReducers from "./injectable";
import SellUsedCarDocuments from "../../../components/shared/sell-used-car-documents";
import SellUsedCarCityList from "../../../components/shared/sell-used-car-city-list";
import GenericBrandBanner from "../../../components/shared/generic-brand-banner";
import useC2bCleverTap from "../../../hooks/use-c2b-clevertap";
import { NUMBER } from "../../../constants/app-constants";

const WhyCars = loadable(() => import("../../../components/desktop/why-cars"));
const SimplestWay = loadable(() => import("../../../components/desktop/simplest-way"));
const PilotFaq = loadable(() => import("../../../components/desktop/pilot-faq"));
const TestimonialCarouselRevamp = loadable(() => import("../../../components/desktop/testimonial-carousel-revamp"));
const TwitterCarousel = loadable(() => import("../../../components/desktop/twitter-carousel"));
const MetaTags = loadable(() => import("../../../components/shared/meta-tags"), {ssr: true});

const Home = ({
    match,
    history,
    updateLeadSourceConnect,
    isSellOnlineFlow,
    setDealerCodeConnect,
    topCities,
    isSSR,
    fetchDataConnect,
    updateSSRStatusConnect,
    statsigDynamicConfigData,
    websiteAdvertisementBannerData
}) => {
    useC2bCleverTap("Sell_car");
    const { pathname } = history.location;
    const variation = homeVariation(pathname);
    const [faqs, setFaqs] = useState([]);

    const memoizedtopCities = useMemo(() => {
        if (topCities && topCities.length) return topCities.slice(NUMBER.ZERO, NUMBER.FOURTY);
        return null;
    }, [topCities]);

    const seoContent = "seo_content";
    const socialMedia = "socialMedia";
    const cmsPayload = {
        cmsuri: "sell-used-cars"
    };
    const { websiteAds = {}} = statsigDynamicConfigData || {};

    useEffect(() => {
        sendGAEvent({
            event: "virtualPageview",
            pageUrl: window.location.href,
            pageTitle: `${isSellOnlineFlow ? "sell online" : "non sell online"}`
        });
    }, [isSellOnlineFlow]);

    useEffect(() => {
        const { location: { search } } = history;
        const queryParams = search && querystring.parse(search.replace(/\?/g, ""));
        if (queryParams && queryParams.source === "UCD" && queryParams.dealerCode && dealerCodeValidator(queryParams.dealerCode)) {
            setDealerCodeConnect(queryParams.dealerCode);
            updateLeadSourceConnect(C2B_LEAD_TYPES.DEALER_REFERRAL);
        } else {
            setDealerCodeConnect("");
            updateLeadSourceConnect(C2B_LEAD_TYPES.SELL_USED_CARS_ORIGINAL);
        }
        updateSSRStatusConnect(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!isSSR && pathname.includes("/sell-used-cars")) {
            fetchDataConnect({...cmsPayload, expand: [seoContent, socialMedia].toString()});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSSR]);

    const onClick = () => {
        sendCustomGaEvents(getCarPriceBottom);
        window.scrollTo(0, 0);
    };

    const onBreadcrumbClick = ({ item }) => {
        if (item === "home") {
            sendCustomGaEvents({
                ...breadcrumbClicked,
                eventLabel: item
            });
            window.location.href = `${appUrl()}/`;
        } else {
            sendCustomGaEvents(breadcrumbClicked);
            window.location.href = `${appUrl()}${item.redirectURL}`;
        }
    };

    const computeBreadcrumbList = () => {
        const list = [{
            displayText: "Sell car"
        }];
        return list;
    };

    const handleCityListGa = (cityName) => {
        sendCustomGaEvents({
            ...popularCityTextClick,
            eventLabel: cityName
        });
    };

    const gaEventMapping = {
        getCarPriceInPageCTA: () => sendCustomGaEvents(getCarPriceInPageCTA),
        sellCarNowInPageCTA: () => sendCustomGaEvents(sellCarNowInPageCTA)
    };

    const isIndexedEnabled = variation.isIndexed;
    const renderDefaultPage = () => (
        <Fragment>
            <div styleName={"styles.buyCarsVariant"}>
                <HomeBanner />
                { websiteAdvertisementBannerData && <div styleName={"styles.adsBanner"}>
                    <GenericBrandBanner config={websiteAds} type={"970x90"} fetchpriority="high" pageType="sell-used-cars"  position = "top" source = "webApp"/>
                </div>
                }
                <div styleName={"styles.wrapper"}>
                    <section>
                        <SellEasySteps/>
                    </section>
                    <LazyComponent>
                        <WhyCars
                            faqs={faqs}
                            setFaqs={setFaqs}
                            isSellerHomepage={true}
                            apiPayload={{...cmsPayload, expand: [seoContent, socialMedia]}}
                        />
                    </LazyComponent>
                </div>
                <div styleName={"styles.customerTestimonials"}>
                    <LazyComponent>
                        <TestimonialCarouselRevamp currentPage={"home"} showDate={false}/>
                    </LazyComponent>
                </div>
                {
                    SELL_CAR_SEO_INFO_SECTIONS.map((section, index) =>
                        (<div styleName={section.styleName} key={index}>
                            <div styleName={"styles.wrapper"}>
                                <SellUsedCarDocuments
                                    heading={section.heading}
                                    buttonText={section.buttonText}
                                    isTipsToSellUsedCars={section.isTipsToSellUsedCars}
                                    gaEventCallback={gaEventMapping[section.gaEvent]}
                                />
                            </div>
                        </div>))
                }
                <div styleName={"styles.twitterCarousel"}>
                    <LazyComponent>
                        <TwitterCarousel />
                    </LazyComponent>
                </div>
                {
                    !!(memoizedtopCities && memoizedtopCities.length) &&
                <div styleName={"styles.sellCarCityList"}>
                    <ErrorHandler>
                        <SellUsedCarCityList cityList={memoizedtopCities} callBack={handleCityListGa} showMoreControl/>
                    </ErrorHandler>
                </div>
                }
                <LazyComponent>
                    <div styleName={"styles.faqWrapper"}>
                        <PilotFaq heading={"Frequently asked questions"} faqs={faqs} columns={1} attachSchema={true}/>
                        <a href="/faq/" target="_blank" styleName="styles.allfqa">view all faqs</a>
                    </div>
                </LazyComponent>

                <LazyComponent>
                    <SimplestWay onClick={onClick} />
                </LazyComponent>
                <BreadcrumbList
                    homeText={"Home"}
                    onClickCallback={onBreadcrumbClick}
                    list={computeBreadcrumbList()}
                    isRevamped = {true}
                    attachSchema={true}
                />
            </div>
        </Fragment>
    );

    return (
        <div>
            <ErrorHandler>
                <MetaTags match={match} isIndexEnabled={isIndexedEnabled} />
            </ErrorHandler>
            {renderDefaultPage()}
            <ErrorHandler>
                <SchemaHome />
            </ErrorHandler>
        </div>
    );
};
Home.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    updateLeadSourceConnect: PropTypes.func,
    isSellOnlineFlow: PropTypes.bool,
    setDealerCodeConnect: PropTypes.func,
    topCities: PropTypes.array,
    isSSR: PropTypes.bool,
    fetchDataConnect: PropTypes.func,
    updateSSRStatusConnect: PropTypes.func,
    statsigDynamicConfigData: PropTypes.object,
    websiteAdvertisementBannerData: PropTypes.bool
};

const mapStateToProps = ({
    sellOnlineCities: {
        isSellOnline: isSellOnlineFlow
    },
    footer: {
        data: {
            top_cities: topCities
        }
    },
    meta: {
        isSSR
    },
    experiments: {
        websiteAdvertisementBanner: {
            data: websiteAdvertisementBannerData
        },
        statsigDynamicConfig: {
            data: statsigDynamicConfigData
        }

    }
}) => ({
    isSellOnlineFlow,
    topCities,
    isSSR,
    statsigDynamicConfigData,
    websiteAdvertisementBannerData
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    updateLeadSourceConnect: updateLeadSource,
    setDealerCodeConnect: setDealerCode,
    fetchDataConnect: fetchData,
    updateSSRStatusConnect: updateSSRStatus
}, dispatch);

export default withReducer(injectableReducers)(mapStateToProps, mapDispatchToProps)(withLayout(Home, true, true, true, false));
